import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LinkedAccountsService {
  private initialLinkedAccounts: string[] = [];
  private sessionLinkedAccounts: string[] = [];
  private initialized = false;

  initialize(linkedAccountIds: string[]): void {
    if (!this.initialized) {
      this.initialLinkedAccounts = linkedAccountIds;
      this.initialized = true;
    }
  }

  addLinkedAccounts(accountIds: string[]): void {
    this.sessionLinkedAccounts = [...this.sessionLinkedAccounts, ...accountIds];
  }

  getAllLinkedAccounts(): string[] {
    return [...this.initialLinkedAccounts, ...this.sessionLinkedAccounts];
  }

  isAccountLinked(accountId: string): boolean {
    return this.getAllLinkedAccounts().includes(accountId);
  }

  reset(): void {
    this.initialLinkedAccounts = [];
    this.sessionLinkedAccounts = [];
    this.initialized = false;
  }
}
